<template>
    <div>
      <form method=post action='https://core.newebpay.com/MPG/mpg_gateway'>MID:<input name='MerchantID' value='MS1722193037' readonly><br>Version: <input name='Version' value='2.0' readonly><br>TradeInfo: <input name='TradeInfo' value='2a7c449ed319bd1e55b252127da7da80c93317b3e87145124c1707d9e3b1966a3ab815e3f3c710fa837e5464d3b8a2e19c8808be701bd45abb004eb038923a5d10f510e3d8b8ae3ba8daae9400b00628cfd6b92dba92c0623cda15711c33efdcf13271206aecce6dbaf8f824cb4afdd63c7ce82838f4246879102ce3b7669e1389bfacf14fe27730ede12368d43fc0c0526925d5e294654bdc49cb1507eab0c8aa43471f29a69fa6e26cb80acc777dc8041f4d2261dbc2e1a24fe9198d970f6b6f0a67917edaf8371398341bb7b396b1b2d9495dfa3cf56ff9121b7d42923574' readonly><br>TradeSha: <input name='TradeSha' value='FFF3811D6C31E452377A56278118D164510A368C855251B21B9F5EBB20D867E9' readonly><br><input type=submit></form>;

      <h1>DeepSeek R1 Model (Streaming)</h1>
      <textarea v-model="inputText" placeholder="Enter your prompt here"></textarea>
      <button @click="generate" :disabled="isGenerating">
        {{ isGenerating ? 'Generating...' : 'Generate Text' }}
      </button>
      <div v-if="outputText">
        <h2>Generated Text:</h2>
        <p>{{ outputText }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import { generateTextStream } from '@/services/api';
  
  export default {
    name:"Deepseek",
    data() {
      return {
        inputText: '',
        outputText: '',
        isGenerating: false,
      };
    },
    methods: {
      async generate() {
        if (!this.inputText.trim()) return;
  
        this.isGenerating = true;
        this.outputText = '';
  
        try {
          await generateTextStream(this.inputText, (chunk) => {
            this.outputText += chunk; // 实时更新生成的文本
          });
        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.isGenerating = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 10px;
  }
  </style>